define('modules/editor/views/page',['require','exports','module','lib/util','base/collectionview','./inline_toolbar','../models/editorstate','./elements/section','ldsh!../templates/page_amp','ldsh!../templates/page','../behaviours/has_resizebox','../behaviours/has_groupbox','../behaviours/has_page_margins','../behaviours/has_alignment_guides'],function (require, exports, module) {
  "use strict";

  var utils = require("lib/util"),
    CollectionView = require("base/collectionview"),
    InlineToolbar = require("./inline_toolbar"),
    EditorState = require("../models/editorstate"),
    GroupState = EditorState.groupState,
    ActiveItemState = EditorState.activeItemState;


  /** PAGE VIEW **/

  /**
   * Page View Controller: handles HTML5 drag & drop operations
   * used ONLY for dragging new elements from the toolbox to
   * the editor page
   * @type {Object}
   */
  var Controller = {
    /**
     * Triggered when something is dragged over the page view
     * Configures the HTML5 Drag operation
     * @param  {object} e Event (non jQuery!)
     */
    onDragover: function (e) {
      e.preventDefault();
      var payload = this.data.state.getDragPayload(),
        dataTransfer = e.originalEvent.dataTransfer;
      dataTransfer.dropEffect = (payload.type === "section") ? payload.op : "none";
    },

    /**
     * Triggered when something is dropped into the page view
     * @param  {Event} e Event (non jQuery)
     */
    onDrop: function (e) {
      e.preventDefault();
      var payload = this.data.state.getDragPayload(),
        ev = e.originalEvent,
        pos = {
          x: ev.clientX + document.body.scrollLeft,
          y: ev.clientY + document.body.scrollTop
        },
        between = this.calculateSurroundingSections(pos),
        reference = between[0],
        after = true;

      if (!reference) {
        reference = between[1];
        after = false;
      }

      if (reference && reference.model !== payload.model) {
        if (payload.op === "copy")
          this.data.addNewSectionAt(reference.model, after);
        else if (payload.op === "move")
          this.data.moveSection(reference.model, payload.model, after);
      } else {
        this.data.addNewSection();
      }
      this.data.state.clearDragPayload();
    },
    /**
     * Calculates which sections are around the drop point
     * @param  {object} pos Drop coordinates
     * @return {Array}     An Array with at most 2 section VIEW references
     */
    calculateSurroundingSections: function (pos) {
      var before, after, afterCenter, beforeCenter,
        sections = this._childViews;
      _.each(sections, function (section) {
        var rect = section.el.getBoundingClientRect(),
          offTop = document.body.scrollTop,
          center = (rect.top + rect.bottom) / 2 + offTop;
        if (pos.y < center && (!afterCenter || center < afterCenter)) {
          // seccion debajo
          after = section;
          afterCenter = center;
        } else if (pos.y >= center && (!beforeCenter || center > beforeCenter)) {
          // seccion encima
          before = section;
          beforeCenter = center;
        }
      });
      return [before, after];
    }
  };

  module.exports = CollectionView.extend({
    initialize: function (options) {
      this.collection = options.data.sections;
      this.listenTo(this.data, "section:added", this._updateGroupStateViews);

      module.exports.__super__.initialize.apply(this, arguments);
    },
    itemView: require("./elements/section"),
    itemContainer: ".js-sections",
    template: function () {
      return this._getPageTemplate();
    },

    // 200px at the bottom so new sections can be added
    attributes: {style: "padding-bottom: 200px;"},

    events: {
      "dragover": "onDragover",
      "drop": "onDrop"
    },

    render: function () {
      this.stopListening(ActiveItemState);
      if (this.inlineToolbar) {
        //clean UP!!
        this.inlineToolbar.remove();
        delete this.inlineToolbar;
      }
      return module.exports.__super__.render.apply(this);
    },

    /**
     * Creates the InlineToolbar View and store the reference
     */
    onRender: function () {
      var self = this;
      this.$el.i18n();
      this.listenTo(ActiveItemState,
        ActiveItemState.CHANGE_ACTIVE_ITEM,
        _.throttle(this.showElementToolbar, 250));
      //is there anything already selected when we re-render?
      if (ActiveItemState.getActiveItem() !== undefined) {
        setTimeout(function () {
          self.showElementToolbar(null, ActiveItemState.getActiveItem());
        }, 250);
      }
    },

    _getPageTemplate: function () {
      // AMP TODO: These two templates are very similar, so we can merge them at some point...
      if (EditorState.getAMPState()) {
        return require("ldsh!../templates/page_amp");
      }

      return require("ldsh!../templates/page");
    },

    _updateGroupStateViews: function () {
      _.invoke(this._childViews, "updateGroupStateViews");
    },

    /**
     * Cleans up the inline toolbar reference
     */
    onRemove: function () {
      if (this.inlineToolbar) {
        this.inlineToolbar.remove();
      }
    },

    /**
     * Activates the element toolbar for the selected element
     * @param  {Model} state       State model
     * @param  {Model} activeModel Selected element's model
     */
    showElementToolbar: function (state, activeModel) {
      if (!this.inlineToolbar) {
        this.inlineToolbar = new InlineToolbar({
          el: this.$(".js-element-toolbar")
        });
      }
      //hide if no element is selected
      //or if there's more than one element selected
      if (!activeModel || GroupState.getGroupCount() > 1) {
        this.inlineToolbar.hide();
      } else {
        var sectionView = this.getElementContainer(activeModel.formModel || activeModel);
        //is this a view that's been removed?
        if (!sectionView || sectionView.$el.length === 0) {
          return;
        }
        if (sectionView) {
          //show toolbar
          this.inlineToolbar.resetControls();
          this.inlineToolbar.show(sectionView);
        } else {
          this.inlineToolbar.hide();
        }
      }
    },

    /**
     * Returns the Section view that contains a specific element Model
     * if Model is a Section, returns its view
     * @param  {Model} element
     * @return {View}
     */
    getElementContainer: function (element) {
      if (element.name === "section") {
        return _.find(this._childViews, function (view) {
          return view.model === element;
        });
      } else {
        return _.find(this._childViews, function (view) {
          return view.model.contains(element);
        }) || this._childViews.reduce(function (container, section) {
          var areas = section._childViews.filter(function (el) {
            return el.model.name === "element:area";
          });
          return container || areas.reduce(function (container, area) {
            return _.find(area._childViews, function (view) {
              return view.model === element;
            }) ? area : container;
          }, false);
        }, false);
      }
    }
  });

  // _.extend(module.exports.prototype, Controller);
  utils.mixin(module.exports, Controller);
  utils.mixin(module.exports, require("../behaviours/has_resizebox"));
  utils.mixin(module.exports, require("../behaviours/has_groupbox"));
  utils.mixin(module.exports, require("../behaviours/has_page_margins"));
  utils.mixin(module.exports, require("../behaviours/has_alignment_guides"));

});

